import { useId } from 'react';
import { APP_NAME } from '@thottbot/shared';

/**
 * Original lookalike of the 2009 Thottbot logo: chiselled blue serif caps over a gold
 * small-caps subtitle, drawn with SVG text and gradients (no raster asset, no dragon).
 * The 393 × 102 viewBox matches the 2009 `div.biglogo` box.
 */
export function Logo({ size }: { size: 'large' | 'small' }) {
  const id = useId();
  const blue = `${id}-blue`;
  const gold = `${id}-gold`;
  const shadow = `${id}-shadow`;
  const width = size === 'large' ? 393 : 140;
  return (
    <svg
      className={`logo logo-${size}`}
      viewBox="0 0 393 102"
      width={width}
      height={Math.round((width * 102) / 393)}
      role="img"
      aria-label={APP_NAME}
    >
      <defs>
        <linearGradient id={blue} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#7f9fff" />
          <stop offset="0.55" stopColor="#3350d6" />
          <stop offset="1" stopColor="#1a2a99" />
        </linearGradient>
        <linearGradient id={gold} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#ffe680" />
          <stop offset="1" stopColor="#b8860b" />
        </linearGradient>
        <filter id={shadow} x="-5%" y="-10%" width="110%" height="130%">
          <feDropShadow dx="1.5" dy="2" stdDeviation="1" floodColor="#000" floodOpacity="0.45" />
        </filter>
      </defs>
      <text
        x="196.5"
        y="58"
        textAnchor="middle"
        fontFamily='Georgia, "Times New Roman", serif'
        fontSize="60"
        fontWeight="bold"
        letterSpacing="2"
        textLength="372"
        lengthAdjust="spacingAndGlyphs"
        fill={`url(#${blue})`}
        stroke="#0b1466"
        strokeWidth="1.5"
        filter={`url(#${shadow})`}
      >
        THOTTBOT
      </text>
      <text
        x="196.5"
        y="90"
        textAnchor="middle"
        fontFamily='Georgia, "Times New Roman", serif'
        fontSize="20"
        fontWeight="bold"
        fontVariant="small-caps"
        letterSpacing="1"
        textLength="376"
        lengthAdjust="spacingAndGlyphs"
        fill={`url(#${gold})`}
        stroke="#5c4a0a"
        strokeWidth="0.6"
      >
        World of Warcraft: Forever Database
      </text>
    </svg>
  );
}
